import { renderSlot as _renderSlot, withModifiers as _withModifiers, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-63de114e"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  for: "tickwidget-fileUpload"
}
const _hoisted_2 = ["data-active"]
const _hoisted_3 = ["data-active"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (this.clickToSelect)
    ? (_openBlock(), _createElementBlock("label", _hoisted_1, [
        _createElementVNode("div", {
          class: _normalizeClass(["drop-zone", { active: this.active }]),
          "data-active": _ctx.active,
          onDragenter: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.setActive && _ctx.setActive(...args)), ["prevent"])),
          onDragover: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.setActive && _ctx.setActive(...args)), ["prevent"])),
          onDragleave: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.setInactive && _ctx.setInactive(...args)), ["prevent"])),
          onDrop: _cache[3] || (_cache[3] = _withModifiers(
//@ts-ignore
(...args) => (this.onDrop && this.onDrop(...args)), ["prevent"]))
        }, [
          _renderSlot(_ctx.$slots, "default", { dropZoneActive: _ctx.active }, undefined, true)
        ], 42, _hoisted_2),
        _createElementVNode("input", {
          id: "tickwidget-fileUpload",
          class: "upload-button",
          type: "file",
          multiple: "",
          onChange: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (this.onInputChange && this.onInputChange(...args)))
        }, null, 32)
      ]))
    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
        _createElementVNode("div", {
          class: _normalizeClass(["cw-drop-zone", { active: this.active }]),
          "data-active": _ctx.active,
          onDragenter: _cache[5] || (_cache[5] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.setActive && _ctx.setActive(...args)), ["prevent"])),
          onDragover: _cache[6] || (_cache[6] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.setActive && _ctx.setActive(...args)), ["prevent"])),
          onDragleave: _cache[7] || (_cache[7] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.setInactive && _ctx.setInactive(...args)), ["prevent"])),
          onDrop: _cache[8] || (_cache[8] = _withModifiers(
//@ts-ignore
(...args) => (this.onDrop && this.onDrop(...args)), ["prevent"]))
        }, [
          _renderSlot(_ctx.$slots, "default", { dropZoneActive: _ctx.active }, undefined, true)
        ], 42, _hoisted_3),
        _createElementVNode("input", {
          id: "tickwidget-fileUpload",
          class: "cw-upload-button",
          type: "file",
          multiple: "",
          onChange: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (this.onInputChange && this.onInputChange(...args)))
        }, null, 32)
      ], 64))
}